import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  course: {
    id: 'portal.views.aboutUs.title.part1',
    defaultMessage: 'Course',
    description: 'Course word in About Us heading',
  },
  overview: {
    id: 'portal.views.aboutUs.title.part2',
    defaultMessage: 'Overview',
    description: 'Overview word in About Us heading',
  },
  lookWithinLeadBeyondTitle: {
    id: 'portal.views.aboutUs.lookWithinLeadBeyond',
    defaultMessage: 'Look within, lead beyond',
    description: 'Welcome text for About Us page',
  },
  lookWithinLeadBeyondText1: {
    id: 'portal.views.aboutUs.lookWithinLeadBeyond.paragraph1',
    defaultMessage: 'At the heart of every remarkable leader lies an unwavering '
      + 'foundation of character. We firmly believe that good leadership begins with '
      + 'character and involves a steadfast commitment to courage, love, and hope.',
    description: 'First paragraph about leadership and character',
  },
  lookWithinLeadBeyondText2: {
    id: 'portal.views.aboutUs.lookWithinLeadBeyond.paragraph2',
    defaultMessage: 'Leading with Character is a 30-day leadership journey designed to '
      + 'help you clarify what it means to lead in your context and build habits that '
      + 'expand your ability to influence positive change.',
    description: 'Second paragraph about the course',
  },
  theCourseTitle: {
    id: 'portal.views.aboutUs.theCourse.title',
    defaultMessage: 'The course',
    description: 'The course section title',
  },
  theCourseText1: {
    id: 'portal.views.aboutUs.theCourse.paragraph1',
    defaultMessage: 'Developed in collaboration between Legatum and academic departments '
      + 'within the University of Oxford and Harvard University, our course is accessible '
      + 'to everyone at no cost, enabling you to learn and evolve at your own pace.',
    description: 'Course developed paragraph',
  },
  theCourseText2: {
    id: 'portal.views.aboutUs.theCourse.paragraph2',
    defaultMessage: 'The course has four central modules, each moving from research and '
      + 'practitioner insight to practical exercises that focus on habit development. '
      + 'Each module contains two to three hours of interactive online content followed '
      + 'by five days of practical exercises, taking approximately 20 minutes a day. '
      + 'The whole course can be completed within 30 days.',
    description: 'Course modules paragraph',
  },
  whyNeededTitle: {
    id: 'portal.views.aboutUs.whyNeeded.title',
    defaultMessage: 'Why is it needed?',
    description: 'Why is it needed section title',
  },
  whyNeededText1: {
    id: 'portal.views.aboutUs.whyNeeded.paragraph1',
    defaultMessage: 'In today’s rapidly changing, uncertain, and interconnected world, the need '
      + 'for leaders of character is more important than ever. We need leaders who possess good '
      + 'judgment, courage, love, and hope, and who inspire others to build a better future together. '
      + 'By embodying integrity, wisdom, and compassion, such leaders build trust, leading to deeper '
      + 'engagement and commitment among followers and stakeholders.',
    description: 'Why needed paragraph 1',
  },
  whyNeededText2: {
    id: 'portal.views.aboutUs.whyNeeded.paragraph2',
    defaultMessage: 'Character is critical to leadership effectiveness, across industries '
      + 'and at all levels, including the highest positions of influence. However, it often '
      + 'remains overlooked in leadership development. Most leadership theories lack in-depth '
      + 'consideration of character and therefore miss out on the foundational principle that '
      + 'a leader’s essence shapes their actions. Similarly, most leadership development '
      + 'programmes emphasise specific, tactical skills, rather than the growth of the whole person.',
    description: 'Why needed paragraph 2',
  },
  whyNeededText3: {
    id: 'portal.views.aboutUs.whyNeeded.paragraph3',
    defaultMessage: 'Leading with Character addresses this gap by incorporating research-based '
      + 'strategies for intentional character development in your leadership journey, strengthening '
      + 'your ability to lead in dynamic, evolving contexts.',
    description: 'Why needed paragraph 3',
  },
  whoIsThisForTitle: {
    id: 'portal.views.aboutUs.whoIsThisFor.title',
    defaultMessage: 'Who is this for?',
    description: 'Who is this for section title',
  },
  whoIsThisForText1: {
    id: 'portal.views.aboutUs.whoIsThisFor.paragraph1',
    defaultMessage: 'This course is designed for individuals from all backgrounds who possess '
      + 'a thirst for personal growth and a desire to elevate their own leadership. Whether you '
      + 'are a seasoned executive, an emerging manager, or someone who aspires to inspire change, '
      + 'this course is a stepping stone towards becoming a more effective leader.',
    description: 'Who is this for paragraph 1',
  },
  whoIsThisForText2: {
    id: 'portal.views.aboutUs.whoIsThisFor.paragraph2',
    defaultMessage: 'Building character and becoming a better leader requires deliberate, sustained '
      + 'effort and consistent practice. Are you ready to take the first step towards becoming the leader '
      + 'you aspire to be? Sign up today and begin the journey of character-based leadership.',
    description: 'Who is this for paragraph 2',
  },
  whoIsThisForText3: {
    id: 'portal.views.aboutUs.whoIsThisFor.paragraph3',
    defaultMessage: 'Together, we will shape the future, one leader at a time.',
    description: 'Who is this for paragraph 3',
  },
  enrollButton: {
    id: 'portal.views.aboutUs.enroll.button.text',
    defaultMessage: 'Enroll',
    description: 'Enroll button text',
  },
  courseOverviewTitle: {
    id: 'portal.views.aboutUs.courseOverview.title',
    defaultMessage: 'Course Overview',
    description: 'Course overview section title',
  },
  characterTitle: {
    id: 'portal.views.aboutUs.character1.title',
    defaultMessage: 'Character: The heart of good leadership',
    description: 'Character overview box title',
  },
  characterListItem1: {
    id: 'portal.views.aboutUs.courseOverview.character.listItem1',
    defaultMessage: 'Explore the fundamentals of Leading with Character',
    description: 'Character overview list item 1',
  },
  characterListItem2: {
    id: 'portal.views.aboutUs.courseOverview.character.listItem2',
    defaultMessage: 'Consider our leadership philosophy',
    description: 'Character overview list item 2',
  },
  characterListItem3: {
    id: 'portal.views.aboutUs.courseOverview.character.listItem3',
    defaultMessage: 'Experience the transformative power of character',
    description: 'Character overview list item 3',
  },
  characterListItem4: {
    id: 'portal.views.aboutUs.courseOverview.character.listItem4',
    defaultMessage: 'Discover how to develop character',
    description: 'Character overview list item 4',
  },
  characterListItem5: {
    id: 'portal.views.aboutUs.courseOverview.character.listItem5',
    defaultMessage: 'Introduce yourself to fellow learners from across the globe',
    description: 'Character overview list item 5',
  },
  purposeTitle: {
    id: 'portal.views.aboutUs.courseOverview.purpose.title',
    defaultMessage: 'Purpose: Clarify your leadership direction and drive',
    description: 'Purpose overview box title',
  },
  purposeListItem1: {
    id: 'portal.views.aboutUs.courseOverview.purpose.listItem1',
    defaultMessage: 'Begin with the essential question: “Why do you lead?”',
    description: 'Purpose overview list item 1',
  },
  purposeListItem2: {
    id: 'portal.views.aboutUs.courseOverview.purpose.listItem2',
    defaultMessage: 'Gain insights from purpose-driven leaders',
    description: 'Purpose overview list item 2',
  },
  purposeListItem3: {
    id: 'portal.views.aboutUs.courseOverview.purpose.listItem3',
    defaultMessage: 'Identify your unique personal purpose',
    description: 'Purpose overview list item 3',
  },
  purposeListItem4: {
    id: 'portal.views.aboutUs.courseOverview.purpose.listItem4',
    defaultMessage: 'Engage in a 5-day challenge, taking daily actions towards your purpose',
    description: 'Purpose overview list item 4',
  },
  courageTitle: {
    id: 'portal.views.aboutUs.courseOverview.courage.title',
    defaultMessage: 'Courage: Fortify your commitment to courageous action',
    description: 'Courage overview box title',
  },
  courageListItem1: {
    id: 'portal.views.aboutUs.courseOverview.courage.listItem1',
    defaultMessage: 'Understand the pivotal role of courage and self-leadership',
    description: 'Courage overview list item 1',
  },
  courageListItem2: {
    id: 'portal.views.aboutUs.courseOverview.courage.listItem2',
    defaultMessage: 'Explore the diverse forms of courage',
    description: 'Courage overview list item 2',
  },
  courageListItem3: {
    id: 'portal.views.aboutUs.courseOverview.courage.listItem3',
    defaultMessage: 'Identify your personal values',
    description: 'Courage overview list item 3',
  },
  courageListItem4: {
    id: 'portal.views.aboutUs.courseOverview.courage.listItem4',
    defaultMessage: 'Reflect on your experiences of acting in alignment with your values',
    description: 'Courage overview list item 4',
  },
  courageListItem5: {
    id: 'portal.views.aboutUs.courseOverview.courage.listItem5',
    defaultMessage: 'Ground your courage in humility',
    description: 'Courage overview list item 5',
  },
  courageListItem6: {
    id: 'portal.views.aboutUs.courseOverview.courage.listItem6',
    defaultMessage: 'Embrace a 5-day challenge, practising courageous leadership daily',
    description: 'Courage overview list item 6',
  },
  loveTitle: {
    id: 'portal.views.aboutUs.courseOverview.love.title',
    defaultMessage: 'Love: Cultivate the relational skills to lead with love',
    description: 'Love overview box title',
  },
  loveListItem1: {
    id: 'portal.views.aboutUs.courseOverview.love.listItem1',
    defaultMessage: 'Consider a relational approach to leadership',
    description: 'Love overview list item 1',
  },
  loveListItem2: {
    id: 'portal.views.aboutUs.courseOverview.love.listItem2',
    defaultMessage: 'Investigate the virtue of generative love in leadership',
    description: 'Love overview list item 2',
  },
  loveListItem3: {
    id: 'portal.views.aboutUs.courseOverview.love.listItem3',
    defaultMessage: 'Practise being a giver, not a taker',
    description: 'Love overview list item 3',
  },
  loveListItem4: {
    id: 'portal.views.aboutUs.courseOverview.love.listItem4',
    defaultMessage: 'Foster a culture of love with psychological safety',
    description: 'Love overview list item 4',
  },
  loveListItem5: {
    id: 'portal.views.aboutUs.courseOverview.love.listItem5',
    defaultMessage: 'Reflect on your experiences with high-performing teams',
    description: 'Love overview list item 5',
  },
  loveListItem6: {
    id: 'portal.views.aboutUs.courseOverview.love.listItem6',
    defaultMessage: 'Hone your skills in effective listening',
    description: 'Love overview list item 6',
  },
  loveListItem7: {
    id: 'portal.views.aboutUs.courseOverview.love.listItem7',
    defaultMessage: 'Embark on a 5-day challenge to expand your capacity for leadership with love',
    description: 'Love overview list item 7',
  },
  hopeTitle: {
    id: 'portal.views.aboutUs.courseOverview.hope.title',
    defaultMessage: 'Hope: Fuel your pursuit of a brighter future',
    description: 'Hope overview box title',
  },
  hopeListItem1: {
    id: 'portal.views.aboutUs.courseOverview.hope.listItem1',
    defaultMessage: 'Recognise the significance of hope in sustaining long-term goals',
    description: 'Hope overview list item 1',
  },
  hopeListItem2: {
    id: 'portal.views.aboutUs.courseOverview.listItem2',
    defaultMessage: 'Draw inspiration from leaders who have upheld hope in adversity',
    description: 'Hope overview list item 2',
  },
  hopeListItem3: {
    id: 'portal.views.aboutUs.courseOverview.hope.listItem3',
    defaultMessage: 'Become a beacon of hope for others',
    description: 'Hope overview list item 3',
  },
  hopeListItem4: {
    id: 'portal.views.aboutUs.courseOverview.hope.listItem4',
    defaultMessage: 'Explore the role of practical wisdom in steering present actions toward future horizons',
    description: 'Hope overview list item 4',
  },
  hopeListItem5: {
    id: 'portal.views.aboutUs.courseOverview.hope.listItem5',
    defaultMessage: 'Take on a 5-day challenge: Inject hope into your team’s pursuit of purpose, mission, and strategy',
    description: 'Hope overview list item 5',
  },
  onwardTitle: {
    id: 'portal.views.aboutUs.courseOverview.onward.title',
    defaultMessage: 'Onward: Plan for ongoing growth and purposeful leadership',
    description: 'Onward overview box title',
  },
  onwardListItem1: {
    id: 'portal.views.aboutUs.courseOverview.onward.listItem1',
    defaultMessage: 'Find renewed inspiration to commit to continuous leadership in your unique context',
    description: 'Onward overview list item 1',
  },
  onwardListItem2: {
    id: 'portal.views.aboutUs.courseOverview.onward.listItem2',
    defaultMessage: 'Craft a personalised plan to integrate character development into your daily life',
    description: 'Onward overview list item 2',
  },
  onwardListItem3: {
    id: 'portal.views.aboutUs.courseOverview.onward.listItem3',
    defaultMessage: 'Celebrate your course completion',
    description: 'Onward overview list item 3',
  },
});

export default messages;
